var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.375 12.125C2.03125 12.125 1.73708 12.0027 1.4925 11.7581C1.2475 11.5131 1.125 11.2188 1.125 10.875V2.75H0.5V1.5H3.625V0.875H7.375V1.5H10.5V2.75H9.875V10.875C9.875 11.2188 9.75271 11.5131 9.50813 11.7581C9.26313 12.0027 8.96875 12.125 8.625 12.125H2.375ZM8.625 2.75H2.375V10.875H8.625V2.75ZM3.625 9.625H4.875V4H3.625V9.625ZM6.125 9.625H7.375V4H6.125V9.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.df7ff72767b1fff462269596e06de66f.svg";
export { ForwardRef as ReactComponent };